import { Module } from '@nestjs/common';
import { MikroOrmModule } from '@mikro-orm/nestjs';
import { JwtService } from '@nestjs/jwt';
import { ConfigService } from '@nestjs/config';
import { UserController } from './controllers/user.controller';
import { UserService } from './services/user.service';
import { User } from './entities/user.entity';
import { Program } from './entities/program.entity';
import { ProgramType } from './entities/program-type.entity';
import { Category } from './entities/category.entity';
import { UserProgram } from './entities/user-program.entity';
import { UserCategory } from './entities/user-category.entity';
@Module({
  imports: [
    MikroOrmModule.forFeature([
      User,
      Program,
      ProgramType,
      Category,
      UserProgram,
      UserCategory
    ]),
  ],
  controllers: [UserController],
  providers: [UserService, JwtService, ConfigService],
  exports: [UserService],
})
export class UserModule {}
